/**
 * True for the Kodi session surface (`/kodi` and `/kodi/<id>`), excluding
 * sibling routes like `/kodi-usage`. ProtectedRoute uses it to suppress the
 * app-wide SupportAccessBanner on Kodi, which mounts its own owner-scoped one.
 * @param {string} pathname
 * @returns {boolean}
 */
export const isKodiRoute = (pathname) => pathname === '/kodi' || pathname.startsWith('/kodi/')
